import React, { useCallback, useEffect, useRef, useState } from 'react'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import L, { LatLngExpression } from 'leaflet'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import { useNavigate } from 'react-router-dom'
import { useModal } from '@/components/modal/Modal'
import { defaultMapCenter } from '@/env/config'
import { MapPopupBody, MapRow, vehicleObject } from '@/components/Map/Map'
import { MapResponse } from './Response'

import 'leaflet/dist/leaflet.css'
import './Map.css'

export const MachineStatisticMap = ({ services, session, data }: {
  services: Services
  session: CurrentSession
  data: MapResponse | undefined
}) => {
  // const pollingRef = useRef<NodeJS.Timeout | null>(null);
  const [map, setMap] = useState<MapResponse | undefined>(undefined)
  const [myposition, setMyPosition] = useState<[number, number] | undefined>(undefined)
  const now = Date.now()
  const activeTime = 5 * 60 * 1000; // fiveMinutesInMs

  // function isActive(dateStr: string): boolean {
  //   const inputDate = new Date(dateStr).getTime();
  //   if (isNaN(inputDate)) {
  //     throw new Error("Invalid date string");
  //   }
  //   return now - inputDate <= activeTime && inputDate <= now;
  // }

  useEffect(() => {
    setMap(data)
  }, [data])

  // async function refreshMap(fromDate?: Date, oldResponse?: MapResponse): Promise<MapResponse> {
  //   return services.session.fetchWithToken(`${fetchUrl}${fetchUrl.includes('?') ? '&' : '?'}fromDate=${fromDate ? fromDate.toISOString() : ''}`).then(async (r) => {
  //     if (r.status !== 200) {
  //       const erros = await r.json()
  //       console.error(erros)
  //       return Promise.reject<MapResponse>()
  //     }
  //     const newResponse: MapResponse = await r.json()
  //     newResponse.rows = newResponse.rows || null
  //     if (oldResponse === undefined) {
  //       return newResponse
  //     }
  //     return mergeMapResponses(oldResponse, newResponse)
  //   })
  // }

  useEffect(() => {
    // Function to handle geolocation success
    const handleSuccess = (location: GeolocationPosition) => {
      const { latitude, longitude } = location.coords
      setMyPosition([latitude, longitude])
    }

    // Function to handle geolocation error
    const handleError = (error: GeolocationPositionError) => {
      console.error('Error obtaining location:', error)
      // Fallback to a default position if geolocation fails
      setMyPosition(undefined)
    }

    // Check if geolocation is available
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(handleSuccess, handleError)
    } else {
      console.error('Geolocation is not supported by this browser.')
      // Fallback to a default position if geolocation is not supported
      setMyPosition(undefined)
    }
  }, [])

  // useEffect(() => {
  //   refreshMap().then(setMap)
  // }, [fetchUrl]);

  // useEffect(() => {
  //   if (map === undefined) {
  //     return;
  //   }
  //   let handle: NodeJS.Timeout;
  //   let isCancelled = false;

  //   const clock = async () => {
  //     if (isCancelled) return;
  //     if (map === undefined) {
  //       return;
  //     }
  //     await refreshMap(map?.time ? new Date(map?.time) : undefined, map).then(setMap);
  //     if (!isCancelled) {
  //       handle = setTimeout(clock, 2000);
  //     }
  //   };

  //   handle = setTimeout(clock, 2000);

  //   return () => {
  //     isCancelled = true;
  //     clearTimeout(handle);
  //   };
  // }, [map, fetchUrl]);

  function findLatestRow(response: MapResponse | undefined): MapRow | undefined {
    if (!response?.rows || response.rows.length === 0) {
      return undefined;
    }

    return response.rows.reduce((latest, current) => {
      return new Date(current.time) > new Date(latest.time) ? current : latest;
    });
  }

  const firstRow = findLatestRow(map);

  const center: LatLngExpression = (firstRow && {
    lat: firstRow.lat,
    lng: firstRow.lng
  }) || myposition || defaultMapCenter

  // function List() {
  //   if (map === undefined) {
  //     return <div className='spinner'></div>
  //   }
  //   return <StaticPaginatedTable<MapRow>
  //     data={map?.rows || []}
  //     initialState={{
  //       pageSize: 5
  //     }}
  //     header={() => <>
  //       {/* // {isDesktopScreen() && <div className='hcol '>{session.translates.for('elements.table.machines.createdAt')}</div>}
  //       // {isDesktopScreen() && <div className='hcol'>{session.translates.for('elements.table.machines.imei')}</div>} */}
  //       <div className='hcol'>{session.translates.for('elements.table.machines.name')}</div>
  //       <div className='hcol'>{session.translates.for('elements.table.machines.type_category')}</div>
  //       <div className='hcol'>{session.translates.for('elements.table.machines.manufacturer')}</div>
  //       <div className='hcol'>{session.translates.for('elements.table.machines.model')}</div>
  //       <div className='hcol'>{session.translates.for('elements.table.machines.internal_number')}</div>
  //       <div className='hcol'></div>
  //     </>}
  //     row={(row) => <>
  //       {/* {isDesktopScreen() && <div className='col'>{formatDate(new Date(row.createdAt))}</div>} */}
  //       {/* {isDesktopScreen() && <div className='col'>{row.imei}</div>} */}
  //       <div className='col'>{row.machine.name}</div>
  //       <div className='col'>{row.machine.type.category ? session.translates.for(`machine.types.${row.machine.type.category}`) : null}</div>
  //       <div className='col'>{row.machine.type.manufacturer}</div>
  //       <div className='col'>{row.machine.type.model}</div>
  //       <div className='col'>{row.machine.internalNumber}</div>
  //       <div className='col icocol' onClick={() => navigate(`/communal/machine/${row.machine.id}`)}>
  //         <i className='svgfont-link' />
  //       </div>
  //     </>}
  //     translates={session.translates}
  //   />
  // }

  if (map === undefined) {
    return <div className='spinner'></div>
  }

  return <MapContainer attributionControl={false} center={center} zoom={13} style={{
    height: '100%',
    minHeight: '410px',
    width: '100%'
  }}>
    <TileLayer
      attribution='evoltag.pl'
      url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
    />
    {map.rows?.map((row) => (
      <Marker
        key={row.imei}
        position={row}
        icon={L.divIcon(vehicleObject(row))} >
        <Popup>
          <MapPopupBody row={row} services={services} session={session} />
        </Popup>
      </Marker>
    ))}

    {myposition ? <Marker
      key='my-location'
      position={myposition}
      icon={L.divIcon({
        className: 'car-icon',
        html: `<img src="/public/img/gps/i_am_here.png" style="width: 32px" />`,
        iconSize: [32, 32], // Adjust size as needed
        iconAnchor: [16, 16], // Anchor point
      })}></Marker> : null}
  </MapContainer>
}

